export default "__VITE_ASSET__DskQ$VhZ__"